import React from 'react';

const IncentivioPaymentsContext = React.createContext();

const { Provider } = IncentivioPaymentsContext;
export { Provider as IncentivioPaymentsProvider };
export default IncentivioPaymentsContext;
